import { render, staticRenderFns } from "./Overlays.vue?vue&type=template&id=90b435dc&scoped=true&"
import script from "./Overlays.vue?vue&type=script&lang=ts&"
export * from "./Overlays.vue?vue&type=script&lang=ts&"
import style0 from "./Overlays.vue?vue&type=style&index=0&id=90b435dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b435dc",
  null
  
)

export default component.exports